import moment from 'moment';
import { FRONT_DF_1 } from 'CONST';

export const emailValidate = (email)  => {
  const regEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;  // eslint-disable-line
  return regEx.test(email);
};

export const fdate = (date, format = FRONT_DF_1) => (date ? moment(date).format(format) : '');